export default {
  title: "Unauthorized",
  description: `<p>Access denied. You don't have permission to view this page.</p>
            <p>If you believe this is a mistake, please contact support.</p>`,
};
